module.exports = __webpack_public_path__ + "static/media/Group1151.6ec113cc.png";